import {useMemo} from "react";

import { useUserContext } from "../../contexts/UserContext";
import { LifestyleResponsesTree } from "./LifestyleResponsesTree";
import { Grid } from "../../UI/Grid";
import { Skeleton } from "../../UI/Skeleton";
import { Box } from "../../UI/Box";
import { UserDetail } from "../UserDetail";

export const ProfileTab = () => {
  const { user, isLoading } = useUserContext();
  const getMajors = () => {
    return user && user.majors ? user.majors.map(el => el.name).toString() : 'N/A';
  };
  const getHousing = () => {
    return user && user.housing ? user.housing.map(el => el.name).toString() : 'N/A';
  };

  const hasAnyLifestyleQuestions = useMemo(() => {
    const freeTextAnswers = user?.userLifestyleQuestionsWithAnswers?.questions?.FREE_TEXT?.map(el => el.userAnswer).filter(el => el) ?? []; //userAnswer
    const selectAnswers = user?.userLifestyleQuestionsWithAnswers?.questions?.SELECT?.flatMap(question => {
      return Object.entries(question.userAnswers)
        .map(([_, value]) => value && value);
    }).filter(el => el) ?? [];
    const sliderAnswers = user?.userLifestyleQuestionsWithAnswers?.questions?.SLIDER?.flatMap(question => {
      return question.userAnswers;
    }).filter(el => el) ?? [];

    const totalQuestions = freeTextAnswers.length + selectAnswers.length + sliderAnswers.length;
    
    return !!(user && user.userLifestyleQuestionsWithAnswers && totalQuestions > 0 && !user.questionsSaved);
  }, [user]);

  return (
    <Box mt={2} maxWidth={700}>
      
      <Grid item xs={12}>
        <UserDetail label="Majors:" isLoading={isLoading} detail={getMajors()} />
      </Grid>
      <Grid item xs={12}>
        <UserDetail label="Housing:" isLoading={isLoading} detail={getHousing()} />
      </Grid>
      
      
      {!isLoading && user && <LifestyleResponsesTree questionsSaved={hasAnyLifestyleQuestions}/>}
      {isLoading && <Skeleton width={150} variant="text" />}
    </Box>
  );
};
